import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface StatCardProps {
  title: string;
  value: string | number;
  icon: BoxIcon;
  iconBgColor: string;
  iconColor: string;
  index: number;
  subtitle?: string;
}
export function StatCard({
  title,
  value,
  icon: Icon,
  iconBgColor,
  iconColor,
  index,
  subtitle
}: StatCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3,
    delay: index * 0.05
  }} className="bg-white rounded-xl p-6 shadow-sm border border-stone-100" data-id="element-1016">
      <div className="flex items-start justify-between mb-4" data-id="element-1017">
        <div className={`p-3 ${iconBgColor} rounded-lg`} data-id="element-1018">
          <Icon className={`w-6 h-6 ${iconColor}`} data-id="element-1019" />
        </div>
      </div>
      <h3 className="text-stone-600 text-sm font-medium mb-1" data-id="element-1020">{title}</h3>
      <p className="text-3xl font-bold text-stone-900" data-id="element-1021">{value}</p>
      {subtitle && <p className="text-stone-500 text-sm mt-1" data-id="element-1022">{subtitle}</p>}
    </motion.div>;
}